import {useContext, useEffect, useState } from 'react';
import './dot.css'
import { GlobalNoContext } from './Global';

const dotRadius = Math.floor(window.innerHeight / 10 / 2);
const screenHeight = window.innerHeight - dotRadius * 2;
const screenWidth = window.innerWidth - dotRadius * 2;


function Orientation() {
  const [orientation, setOrientation] = useState({
    alpha: 0,
    beta: 0,
    gamma: 0,
  });
  const handleOrientationChange = (event) => {
    let cutAlpha = parseInt(event.alpha);
    let cutBeta = parseInt(event.beta);
    let cutGamma = parseInt(event.gamma)

    setOrientation({
      alpha: cutAlpha,
      beta: cutBeta,
      gamma: cutGamma,
    });


    function moveDistance(angle, cutLocation, max) {
      cutLocation = parseInt(cutLocation.slice(0, cutLocation.lastIndexOf('px')))
      // let fixAngle = 0;
      // if (angle < -90) {
      //   fixAngle = -90;
      // } else if (angle > 90) {
      //   fixAngle = 90;
      // } else {
      //   fixAngle = angle;
      // }
      // let distance = angle/10 * (cutTime - lastTime);  // * pixel this period
      // let distance = parseInt((cutTime - lastTime) / 10000) * 1;
      const distance = angle === 0 ? 0 : parseInt(angle / 2) * 1.2;
      console.log(angle, distance);
      let newLocation = cutLocation + distance;
      if (newLocation < 0) {
        newLocation = 0;
      } else if (newLocation > max) {
        newLocation = max;
      }
      return newLocation + "px";
    }
    
    // get all dot and  relocation each dot
    let dots = document.getElementsByClassName('dot');
    for (let i = 0; i < dots.length; i++) {
      const element = dots[i];
      console.log("^", element.style.left, element.style.top);
      element.style.left = moveDistance(event.gamma, element.style.left, screenWidth);
      element.style.top = moveDistance(event.beta, element.style.top, screenHeight);
      console.log("-", element.style.left, element.style.top);
    }
  };

  function checkDeviceType() {
    var userAgent = navigator.userAgent.toLowerCase();
    if (/mobile|android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)) {
        return "mobile";
    } else {
        return "desktop";
    }
  }

  const listenOriention = () => {
    if (DeviceOrientationEvent
      && DeviceOrientationEvent.requestPermission
      && typeof DeviceOrientationEvent.requestPermission === 'function'
    ) {
        DeviceOrientationEvent.requestPermission().then(permissionState => {
          if(permissionState === "granted") {
            window.addEventListener('deviceorientation', handleOrientationChange);
          } else if(permissionState === "denied") {
            console.warn("用户拒绝授权。");
          }
        });
    } else if ('DeviceOrientationEvent' in window) {
        window.addEventListener('deviceorientation', handleOrientationChange);
    } else {
      alert("设备不支持")
    }

  }
  
  // 监听设备方向变化 useEffect 自动加到全局，但ios设备需要授权支持，需要主动调用，详见listenOriention
  // useEffect(() => {
  //   // if ('DeviceOrientationEvent' in window) {
  //     window.addEventListener('deviceorientation', handleOrientationChange);
  //     return () => {
  //       // 在组件卸载时移除监听器
  //       window.removeEventListener('deviceorientation', handleOrientationChange);
  //     };
  //   // } else {
  //   //   alert("浏览器不支持DeviceOrientationEvent");
  //   // }
  // }, []);
  
  return (
    <div>
      <button onClick={listenOriention}>开始</button>
      <text id='alpha'>Alpha: {orientation.alpha}</text>
      <text id='beta'>Beta: {orientation.beta}</text>
      <text id='gamma'>Gamma: {orientation.gamma}</text>
    </div>
  );
};

function Dot({color="red", top=parseInt(Math.random() * screenHeight) + "px", left=parseInt(Math.random() * screenWidth) + "px"}) {
  // init param

  if (top.indexOf('%') >= 0) {
    top = parseFloat(top.slice(0, top.lastIndexOf("%"))) / 100 * screenHeight + "px";
  }
  if (left.indexOf('%') >= 0) {
    left = parseFloat(left.slice(0, left.lastIndexOf("%"))) / 100 * screenWidth + "px";
  }
  let {dotNo, setDotNo} = useContext(GlobalNoContext);
  function handleClick(event) {
    // 获取点击的圆形元素
    const circle = event.target;
    const svg = circle.parentNode;
    const textElements = svg.querySelectorAll('text');
    if (textElements.length > 0 ) {
      return;
    }

    // 点击显示序号
    setDotNo(dotNo + 1);

    textElements.forEach((text) => {
      if (text) {
        text.remove();
      }
    });

    // 获取圆形的中心坐标
    const cx = parseFloat(circle.getAttribute('cx'));
    const cy = parseFloat(circle.getAttribute('cy'));
    // const cx = svg.style.left;
    // const cy = svg.style.top;
    // 创建文本元素
    const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
    text.textContent = dotNo;
    text.setAttribute('x', cx);
    text.setAttribute('y', cy);
    text.setAttribute('text-anchor', 'middle');
    text.setAttribute('font-size', dotRadius);
    text.setAttribute('fill', "white");
    text.setAttribute('dominant-baseline', 'middle');
    // 将文本元素添加到 SVG 中
    svg.appendChild(text);
  }

  const dotId = 'dot-' + dotNo;
  return (
      // <div>
    <svg id={dotId} class='dot' width={dotRadius * 2} height={dotRadius * 2} style={{left: left, top: top}}>
      <circle cx={dotRadius} cy={dotRadius} r={dotRadius} fill={color} onClick={handleClick}/>
    </svg> 
      /* </div> */
    );
    
}

export {Dot, Orientation};